import React from 'react';

interface Step {
  label: string;
  completed: boolean;
  active: boolean;
}

interface ProgressIndicatorProps {
  steps: Step[];
}

export const ProgressIndicator: React.FC<ProgressIndicatorProps> = ({ steps }) => {
  return (
    <div className="w-full py-6">
      <div className="flex items-center justify-between">
        {steps.map((step, index) => (
          <React.Fragment key={index}>
            <div className="flex flex-col items-center flex-1">
              <div
                className={`w-10 h-10 rounded-full flex items-center justify-center font-bold transition-all duration-300 ${
                  step.completed
                    ? 'bg-primary-600 text-white'
                    : step.active
                    ? 'bg-primary-100 text-primary-600 ring-4 ring-primary-400'
                    : 'bg-gray-200 text-gray-500'
                }`}
              >
                {step.completed ? '✓' : index + 1}
              </div>
              <div
                className={`mt-2 text-xs md:text-sm font-medium ${
                  step.active ? 'text-primary-600' : 'text-gray-500'
                }`}
              >
                {step.label}
              </div>
            </div>
            {index < steps.length - 1 && (
              <div
                className={`flex-1 h-1 mx-2 transition-all duration-300 ${
                  step.completed ? 'bg-primary-600' : 'bg-gray-200'
                }`}
              />
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};
